<script setup>
import { ref, computed, useAttrs } from 'vue'
import dealStatus from '@/utils/dealStatus'

defineOptions({inheritAttrs: false})
const attrs = useAttrs()

const props = defineProps({
  statusCode: { type: String, required: true, default: '??' },
})

const cssClasses = computed(() => {
  const arr = []
  // add the bg color class using the status code
  arr.push(dealStatus.cssClass(props.statusCode))
  // add any classes attached to the component so we can customize style if needed
  if (attrs.class) {
    arr.push(attrs.class)
  }
  return arr.join(' ')
})
</script>

<template lang="pug">
.status-tag.border-round-lg(
  :class="cssClasses"
  v-bind="attrs"
) {{ statusCode }}
//- pre status: {{ dealStatus.object(statusCode) }}
</template>